import Grid from '@material-ui/core/Grid';
import PhotoIcon from '@material-ui/icons/Photo';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import SettingsIcon from '@material-ui/icons/Settings';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Modal from '@material-ui/core/Modal';
import { createStyles, makeStyles, Theme, Tooltip } from '@material-ui/core';

import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { baseTheme } from '../../../../../theme';
import PostDatePicker from '../../post-header/post-date-picker';
import PhotoUploader from '../../../../photo-uploader';
import HighlightSettings from '../highlight-settings';
import { updateHighlight } from '../../../../../services/posts';
import { updatePostHighlight } from '../../../../../store/posts/actions';
import { removeImage, uploadPostImages } from '../../../../../services/storage';
import { deleteHighlightAction, setAppLoadingState } from '../../../../../store';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
    },
    iconButtons: {
      color: theme.palette.primary.dark,
    },
    iconSize: {
      fontSize: '25px',
    },
    iconImage: {
      width: '49px',
      height: '49px',
    },
    centerContent: {
      textAlign: 'center',
    },
    preveiwImage: {
      maxWidth: '100%',
      maxHeight: '50px',
    },
    previewContainer: {
      position: 'relative',
    },
    imageRemover: {
      backgroundColor: theme.palette.background.default,
      borderRadius: '25px',
      position: 'absolute',
      top: '-5px',
      right: '0px',

      '& button': {
        padding: '0',
      },
    },
    modal: {
      position:'absolute',
      top:'10%',
      left:'10%',
      overflow:'scroll',
      height:'100%',
      display:'block',
    },
  }),
);

export default function PostHighlightItem(props: any) {
  const { content, notificationDate, image, postId, id, order, creation, updated, owner,
      textColor, textSize, textPosition, backgroundColor } = props;
  const classes = useStyles(baseTheme);
  const [isOpen, setIsOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const baseUpdate = {
    id,
    postId,
    image,
    content,
    notificationDate,
    order,
    creation,
    updated,
    owner,
    textColor,
    textSize,
    textPosition,
    backgroundColor,
  };

  const uploadImage = async (blobUrl: string, fileName: string) => {
    setAppLoadingState(dispatch, true);
    const uploadImageURL = await uploadPostImages(blobUrl, `${id}_${fileName}`);
    const update = {
      ...baseUpdate,
      image: uploadImageURL,
    };
    await updateHighlight(update);
    updatePostHighlight(dispatch, update);
    setAppLoadingState(dispatch, false);
    window.location.reload();
    toggleModal();
  };

  const handleRemoveImage = (fileName: string) => async (event: any) => {
    const update = {
      ...baseUpdate,
      image: '',
    };
    await removeImage(fileName);
    await updateHighlight(update);
    updatePostHighlight(dispatch, update);
  };

  const handleContentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const update = {
      ...baseUpdate,
      content: event.target.value,
    };
    updatePostHighlight(dispatch, update);
  };

  const handleContentSave = () => {
    updateHighlight({
      ...baseUpdate,
      content,
    });
  };

  const shareContent = () => {
    console.log('share content');
  };

  const handleSetDate = async (value: any) => {
    const update = {
      ...baseUpdate,
      notificationDate: value,
    };
    await updateHighlight(update);
    updatePostHighlight(dispatch, update);
  };
  const handleSetHighlightInfo = async (
      colorValue: string = '',
      sizeValue: string = '',
      positionValue: string = '',
      backColorValue: string = '',
  ) => {
    const update = {
      ...baseUpdate,
      textColor: colorValue,
      textSize: sizeValue,
      textPosition: positionValue,
      backgroundColor: backColorValue,
    };
    await updateHighlight(update);
    updatePostHighlight(dispatch, update);
    toggleSettingsModal();
  };

  const handleDeleteHighlight = async () => {
    await removeImage(image);
    await deleteHighlightAction({
      postId,
      id,
    },
      dispatch);
  };

  const toggleModal = () => setIsOpen(!isOpen);
  const toggleSettingsModal = () => setSettingsOpen(!settingsOpen);
  return (
    <Grid item container className={classes.root} direction="row" alignItems="center" spacing={1}>
      <Grid item xs={1} className={classes.centerContent}>
        {image !== '' ?
          (<div className={classes.previewContainer}>
            <img
              src={image}
              alt="preview"
              className={classes.preveiwImage}
              onClick={toggleModal} />
            <span className={classes.imageRemover}>
              <IconButton
                className={classes.iconButtons}
                aria-label="remove highlight"
                onClick={handleRemoveImage(image)}>
                <HighlightOffIcon className={classes.iconSize} />
              </IconButton>
            </span>
          </div>)
          : (
            <IconButton
              className={classes.iconButtons}
              aria-label="upload image"
              onClick={toggleModal}>
              <PhotoIcon className={classes.iconSize} />
            </IconButton>)
        }

        <IconButton
          className={classes.iconButtons}
          aria-label="settings"
          onClick={toggleSettingsModal}>
          <SettingsIcon className={classes.iconSize} />
        </IconButton>
      </Grid>
      <Grid item xs={9}>
        <TextField
          label="Highlight"
          placeholder="Add highlight here"
          variant="outlined"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          value={content}
          onBlur={handleContentSave}
          onChange={handleContentChange}
          size="small"
        />
      </Grid>
      {/*<Tooltip title="Schedule Highlight">
          <Grid item xs={3}>
            <PostDatePicker
                date={notificationDate}
                setSelectedDate={handleSetDate}
                disabled={true}
            />
          </Grid>
      </Tooltip>
      */}
      <Grid item xs={2} className={classes.centerContent}>
          <Tooltip title="Share">
            <IconButton
              className={classes.iconButtons}
              aria-label="share highlight"
              onClick={shareContent}
              disabled={false}
            >
              <img
                className={classes.iconImage}
                src="/images/share.svg"
              />
            </IconButton>
          </Tooltip>
        <IconButton
          className={classes.iconButtons}
          aria-label="remove highlight"
          onClick={handleDeleteHighlight}>
          <HighlightOffIcon className={classes.iconSize} />
        </IconButton>
      </Grid>

      <Modal
        open={isOpen}
        onClose={toggleModal}
        className={classes.modal}
      >
        <PhotoUploader title="Image Upload" cancelUpload={toggleModal} uploadPhoto={uploadImage} />
      </Modal>
      <Modal
        open={settingsOpen}
        onClose={toggleSettingsModal}
        className={classes.modal}
      >
        <HighlightSettings
            saveSettings={handleSetHighlightInfo}
            cancelSave={toggleSettingsModal}
            textColor={textColor}
            textSize={textSize}
            textPosition={textPosition}
            backgroundColor={backgroundColor}
        />
      </Modal>
    </Grid >
  );
}
